import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useAuth = (): {
  isAuthenticated: boolean;
  nextStep: string | null;
} => {
  const { token, nextStep } = useSelector((state: any) => state.auth);

  const isAuthenticated = useMemo(() => !!token, [token]);

  return {
    isAuthenticated,
    nextStep,
  };
};
